<template lang="pug">
    .article-slots-tab
        .help {{ $t('Leave every slot selected to sell the whole event. Narrow it to sell a shorter ticket - the first evenings of a course, say - as its own variant.') }}

        //- A new variant sells the whole event unless the merchant narrows it.
        EventSlotPicker(
            :event-id="eventId"
            :value="form.slots || []"
            select-all-when-empty
            @input="changeSlots"
        )
</template>

<i18n>
{
    "de": {
        "Leave every slot selected to sell the whole event. Narrow it to sell a shorter ticket - the first evenings of a course, say - as its own variant.": "Alles ausgewählt lassen, um die ganze Veranstaltung zu verkaufen. Eingrenzen, um ein kürzeres Ticket - etwa die ersten Abende eines Kurses - als eigene Variante zu verkaufen."
    }
}
</i18n>

<script>
import _ from 'lodash';

import pinia from '@/pinia';
import { useShopArticleStore, useShopProductStore } from '@/stores';
import EventSlotPicker from '@/extensions/shop/views/Product/Partials/EventSlotPicker';

/**
 * The dates one ticket variant admits to.
 *
 * A variant with nothing of its own admits to everything its product covers, which is how every
 * ticket sold before per-variant dates existed keeps working - see Article::eventSlotsOrProduct().
 */
export default {
    name: 'ArticleSlotsTab',
    components: {
        EventSlotPicker,
    },
    computed: {
        shopArticleStore() {
            return useShopArticleStore(pinia);
        },
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        form() {
            return this.shopArticleStore.form;
        },
        /**
         * Taken from the product: a variant cannot admit to a date its product does not cover, and
         * the product is what was validated against event, shop and bookings.
         */
        eventId() {
            return _.get(this.shopProductStore.initialProduct, 'slots.0.event.id')
                || _.get(this.shopProductStore.form, 'slots.0.event.id')
                || null;
        },
    },
    methods: {
        changeSlots(slots) {
            this.shopArticleStore.setFormSlots(slots);
        },
    },
};
</script>

<style lang="sass" scoped>
.article-slots-tab
    .help
        display: block
        margin-bottom: .75rem
        font-size: 12px
        line-height: 1.4
        color: var(--color-text-muted, #909399)
</style>
